@if(!isUndefined()){
    <app-navbar></app-navbar>
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="row">
                        <div class="col-9 col-xs-6">
                            <div class="inter fs-7 mt-3 mb-3 fw-medium breadcrumb cl-1">
                                <a [routerLink]="['/']" class="text-decoration-none">
                                    <strong>Home</strong>
                                </a>
                                <img src="assets/icons/arrow_right.svg" alt="Breadcrumb"> 
                                <a [routerLink]="['/featured', limit(), page()]" class="text-decoration-none">
                                    <strong>Featured</strong>
                                </a>
                            </div>
                        </div>
                        <div class="col-3 col-xs-6">
                             @if(results() > 0){
                                <span class="float-end inter fs-7 mt-3 mb-3 fw-medium text-secondary">Result{{results() > 1 ? 's' : ''}}: {{results() | number}}</span>
                            }
                        </div>
                    </div>
                    @if(isLoading()){
                        @for (item of [].constructor(limit()); track $index) {
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '480px', 'margin-bottom': '5px', 'width': '98%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '8%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '40%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="5" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '10px', 'padding-bottom': '10px', 'width': '98%' }"></ngx-skeleton-loader>
                        }
                    }@else{
                        @for (obj of articles(); track obj.title) {
                            <div class="rounded-2 mb-3 border-light border rounded-3" animate.enter="fadein" animate.leave="fadeout">
                                <div class="mb-5">
                                    <div class="thumbnail-lg w-100 mb-3 bg-white border border-light rounded-top-start rounded-top-end">
                                        <a [routerLink]="['/article', obj.categorySlug , obj.slug]">
                                            <img [src]="obj.img" [alt]="obj.title" class="object-fit-cover w-100 article-featured-img rounded-top-start rounded-top-end">
                                        </a>
                                    </div>
                                    <div class="fs-7 p-0 inter ps-3 pe-3">
                                        <a [routerLink]="['/categories', obj.categorySlug, limit(), 1]" class="text-decoration-none border border-gray rounded-4 py-1 px-2 text-dark category">
                                            <img src="assets/icons/tag.svg" [alt]="obj.category">  {{obj.category}}
                                        </a>
                                    </div>
                                    <h2 class="fs-5 fw-bold ps-3 pe-3">
                                        <a [routerLink]="['/article', obj.categorySlug , obj.slug]" class="text-decoration-none title">{{obj.title}}</a>
                                    </h2>
                                    <div class="fs-7 fw-medium inter mb-2 mt-3 ps-3 pe-3 border-light border-bottom pb-3">
                                        <div class="author-img border border-light d-inline-block rounded-circle">
                                            <a [routerLink]="['/authors', obj.authorSlug, limit(), 1]">
                                                <img [src]="obj.authorImg" [alt]="obj.author" class="w-100 object-fit-cover">
                                            </a>
                                        </div>
                                        <div class="author">
                                            <a [routerLink]="['/authors', obj.authorSlug, limit(), 1]" class="text-decoration-none text-dark">{{obj.author}}</a>
                                            <span>
                                                <img src="assets/icons/calendar.svg" [alt]="(obj.createdAt | date: 'mediumDate')"> 
                                                {{obj.createdAt | date: 'mediumDate'}}
                                            </span>
                                            <span>
                                                <img src="assets/icons/clock.svg" [alt]="obj.minsRead + ' mins' + ' read'"> 
                                                {{obj.minsRead}} min{{obj.minsRead > 1 ? 's' : ''}} read
                                            </span>
                                            @if(obj.isFeatured){
                                            <span>
                                                <img src="assets/icons/featured_badge.svg" alt="Featured"> 
                                                <a [routerLink]="['/featured', limit(), 1]" class="text-decoration-none text-dark ps-1">Featured</a>
                                            </span>
                                        }
                                        </div>
                                    </div>
                                    <div [innerHtml]="obj.summary" class="fs-6 pt-2 lh-lg fw-medium inter truncate ps-3 pe-3 mb-0"></div>
                                    <div class="col-lg-12">
                                        <div class="mt-2 mb-1">
                                            <span class="d-inline-flex align-items-center float-start ms-3">
                                                <div class="fb-share-button"
                                                    [attr.data-href]="obj.canonical"
                                                    data-layout="button"
                                                    data-size="small">
                                                </div>
                                            </span>
                                            <span class="d-inline-flex align-items-center twitter-x-btn float-start ms-3">
                                                <a href="https://twitter.com/share"
                                                class="twitter-share-button"
                                                [attr.data-url]="obj.canonical"
                                                [attr.data-text]="obj.title"
                                                data-show-count="false"
                                                data-size="small">
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="container p-0 mb-3">
                            <div class="row">
                                <div class="col-6">
                                    <button type="button" (click)="prev()" class="btn btn-outline-dark float-start inter fs-6" [disabled]="!prevBtn() || isLoading()">Prev Page</button>
                                </div>
                                <div class="col-6">
                                    <button type="button" (click)="next()" class="btn btn-outline-dark float-end inter fs-6" [disabled]="!nextBtn() || isLoading()">Next Page</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div class="col-lg-4">
                    <div class="position-sticky widget">
                        <app-widget-recents></app-widget-recents>
                        <app-widgets></app-widgets>
                    </div>
                </div>
            </div>
        </div>
    <app-footer></app-footer>
}@else{
    <app-page-not-found></app-page-not-found>
}